import * as Redux from "redux";
import { UIPositioning } from "../Settings/UITheme";
const ADD_TRACK = "ADD_TRACK";
const REMOVE_TRACK = "REMOVE_TRACK";
const SET_TRACKS = "SET_TRACKS";
const EDIT_ATTRIBUTE = "EDIT_ATTRIBUTE";
const initialState = {
    tracks: []
};
function UITrackReducer(state = initialState, action) {
    switch (action.type) {
        case ADD_TRACK:
            return {
                tracks: [...state.tracks, action.track]
            };
        case REMOVE_TRACK:
            let newTracks = state.tracks.filter((t, index) => index != action.index);
            if (newTracks.length > 0) {
                newTracks[0].startY = UIPositioning.timelineHeaderHeight;
                for (let i = 1; i < newTracks.length; i++) {
                    newTracks[i].startY = newTracks[i - 1].startY + newTracks[i - 1].height;
                }
            }
            return { tracks: newTracks };
        case SET_TRACKS:
            return { tracks: action.tracks };
        default:
            return state;
    }
}
export const UITrackStore = Redux.createStore(UITrackReducer);
//# sourceMappingURL=UITrackStore.js.map